import {
	HttpHandler,
	HttpProgressEvent,
	HttpInterceptor,
	HttpSentEvent,
	HttpHeaderResponse,
	HttpUserEvent,
	HttpRequest,
	HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class NoCacheHttpInterceptor implements HttpInterceptor {
	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
		const nextReq = req.clone({
			headers: req.headers.set('Cache-Control', 'no-cache').set('Pragma', 'no-cache').set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT'),
		});

		return next.handle(nextReq);
	}
}
